module.exports = __webpack_public_path__ + "060a13d1c62ec575dec5a3b37933a7a9.svg";